import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Flex,
  Icon,
  Box,
  useDisclosure,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  SimpleGrid,
  Text,
  Heading,
} from '@chakra-ui/react';
import {
  CheckCircleIcon,
  WarningIcon,
  TimeIcon,
  InfoIcon,
  TriangleUpIcon,
  TriangleDownIcon,
  SearchIcon,
} from '@chakra-ui/icons';
import { useState, useEffect } from 'react';
import ModalSolicitud from './ModalSolicitud';
import { FaClock, FaPrint, FaReceipt, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import ModalHistorialLicencia from './ModalHistorialLicencia';

interface Licencia {
  Id: number;
  usuarioId: number;
  ine: string | null;
  FolioLicencia: string | null;
    Estatus: string | null;

  Ciudadano: string;
  nombreEstablecimiento?: string;
  giro: string | null;
  tipo: string | null;
  Movimiento: string | null;
  localidad?: string | null;
  direccionx: string | null;
  Calle?: string | null;
  numero?: string | null;
  codigoPostal?: string | null;
  Horario: string | null;
  fechaRegistro: string;
  montoLicencia?: number;
  montoResiduos?: number;
  residuos?: boolean;
}

const TablaLicencias = () => {
  const [licencias, setLicencias] = useState<Licencia[]>([]);
  const [filtroTexto, setFiltroTexto] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [filtroGiro, setFiltroGiro] = useState('');
  const [filtroLocalidad, setFiltroLocalidad] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);
  const [registrosPorPagina] = useState(50);
  const [sortConfig, setSortConfig] = useState<{ key: keyof Licencia; direction: 'asc' | 'desc' } | null>(null);

  const formatearFecha = (fechaISO: string) => {
    if (!fechaISO) return '—';
    const [año, mes, dia] = fechaISO.split('T')[0].split('-');
    return `${dia}/${mes}/${año}`;
  };
  const { isOpen: isVerOpen, onOpen: onVerOpen, onClose: onVerClose } = useDisclosure();
  const [licenciaSeleccionada, setLicenciaSeleccionada] = useState<Licencia | null>(null);
  const [modoModal, setModoModal] = useState<'view' | 'edit'>('view');
const [licenciaIdHistorial, setLicenciaIdHistorial] = useState<number | null>(null);
const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const fetchLicencias = async () => {
      try {
const res = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/licencias-comercio`);
        const data = await res.json();
        setLicencias(data);
      } catch (error) {
        console.error('Error al cargar licencias:', error);
      }
    };

    fetchLicencias();
  }, []);

  const requestSort = (key: keyof Licencia) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig?.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key: keyof Licencia) => {
    if (!sortConfig || sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? <TriangleUpIcon ml={1} /> : <TriangleDownIcon ml={1} />;
  };


  const imprimirTicketLicencia = (lic: Licencia, monto: number) => {
  const fecha = new Date();
  const fechaTexto = fecha.toLocaleDateString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const horaTexto = fecha.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  const toNumber = (v: any) => {
  const n = Number(String(v ?? 0).replace(/[^\d.-]/g, ''));
  return isNaN(n) ? 0 : n;
};

type ConceptoItem = { nombre: string; monto: number };

// 1) Obtener conceptos (nuevo esquema o legado)
let conceptos: ConceptoItem[] = [];
if (Array.isArray((lic as any)?.conceptos)) {
  conceptos = (lic as any).conceptos
    .map((c: any) => ({ nombre: String(c?.nombre ?? c?.concepto ?? '').trim(), monto: toNumber(c?.monto ?? c?.importe) }))
    .filter((c: ConceptoItem) => c.nombre.length > 0);
} else if (typeof lic?.Movimiento === 'string' && lic.Movimiento.trim()) {
  conceptos = lic.Movimiento.split('|').map(t => t.trim()).filter(Boolean).map(token => {
    const [nombreRaw, montoRaw] = token.split(':');
    return { nombre: (nombreRaw ?? token).trim(), monto: toNumber(montoRaw) };
  }).filter(c => c.nombre.length > 0);
}

// 2) Partidas base
const montoLicenciaNum = toNumber(lic?.montoLicencia);
const montoResiduosNum = lic?.residuos ? toNumber(lic?.montoResiduos) : 0;
const totalConceptos = conceptos.reduce((acc, c) => acc + toNumber(c.monto), 0);
const total = montoLicenciaNum + montoResiduosNum + totalConceptos;

// 3) Render filas HTML
const row = (label: string, amount: number) =>
  `<div class="row"><span>${label}</span><span>$${amount.toFixed(2)}</span></div>`;

const conceptosRows = conceptos.length
  ? conceptos.map(c => row(c.nombre, toNumber(c.monto))).join('\n')
  : `<div class="row"><span>—</span><span>$0.00</span></div>`;

const residuosRow = montoResiduosNum > 0 ? row('Residuos sólidos', montoResiduosNum) : '';


  const html = `
<html>
  <head>
    <title>Ticket</title>
    <style>
      @media print {
        body { width: 80mm; margin: 0; font-family: monospace; font-size: 12px; }
      }
      body {
        width: 80mm; margin: 0; padding: 10px;
        font-family: monospace; font-size: 12px; white-space: pre-wrap;
      }
      .center { text-align: center; }
      .bold { font-weight: bold; }
      .divider { border-top: 1px dashed #000; margin: 8px 0; }
      .row { display: flex; justify-content: space-between; margin-bottom: 4px; }
      .section-title { margin-top: 4px; margin-bottom: 4px; }
    </style>
  </head>
  <body>
    <div class="center bold">MUNICIPIO DE TOTOLAC</div>
    <div class="center">Desarrollo Economico</div>
    <div class="divider"></div>

    <div class="row"><span>Folio: ${(lic.FolioLicencia ?? lic.Id)}</span><span>Fecha: ${fechaTexto}</span></div>
    <div class="row"><span>Ciudadano:</span><span>${(lic.Ciudadano ?? '').toUpperCase()}</span></div>
    <div class="row"><span>Negocio:</span><span>${(lic.nombreEstablecimiento ?? '—').toUpperCase()}</span></div>
    <div class="row"><span>Hora:</span><span>${horaTexto}</span></div>

    <div class="divider"></div>
    <div class="center bold section-title">DETALLE DE COBRO</div>

    ${row('Licencia', montoLicenciaNum)}
    <div class="row"><span class="bold">Conceptos</span><span></span></div>

    ${conceptosRows}
    ${residuosRow}

    <div class="divider"></div>
    <div class="center bold">TOTAL A PAGAR:</div>
    <div class="center bold" style="font-size: 16px;">
      $${total.toFixed(2)} MXN
    </div>

    <div class="divider"></div>
    <div class="center">¡Gracias por su trámite!</div>

    <script>
      window.onload = function () { window.print(); };
    </script>
  </body>
</html>
`;


  const ventana = window.open('', '_blank', 'width=400,height=600');
  if (ventana) {
    ventana.document.write(html);
    ventana.document.close();
  }
};



  const imprimirLicencia = (lic: Licencia) => {
  const fecha = lic.fechaRegistro?.split('T')[0] ?? '';
  const [anio, mes, dia] = fecha.split('-');

  const html = `
    <html>
      <head>
        <title>Licencia</title>
        <style>
          @media print {
            body {
              margin: 0;
              padding: 0;
            }
          }
          body {
            position: relative;
            width: 21cm;
            height: 27.9cm; /* Tamaño carta */
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 12pt;
          }
          .campo {
            position: absolute;
            text-transform: uppercase; /* <- esto pone todo en MAYÚSCULAS */

          }
          #giro { top: 130px; left: 1px; }
          #aperturaorefrendo { top: 210px; left: 1px; }
          #anio { top: 300px; left: 1px; }
          #ciudadano { top: 120px; left: 470px; }
          #nombreNegocio { top: 200px; left: 550px; }
          #direccionx { top: 240px; left: 480px; }
          #horario { top: 310px; left: 470px; }
          #fecha1 { top: 365px; left: 280px; }
          #fecha2 { top: 365px; left: 400px; }
          #fecha3 { top: 365px; left: 600px; }

        </style>
      </head>
      <body>
        <div id="giro" class="campo">${lic.giro ?? ''}</div>
        <div id="aperturaorefrendo" class="campo">${lic.Estatus ?? 'Apertura'}</div>
        <div id="anio" class="campo">${anio ?? ''}</div>
        <div id="ciudadano" class="campo">${lic.Ciudadano  ?? ''}</div>
        <div id="nombreNegocio" class="campo">${lic.nombreEstablecimiento  ?? ''}</div>
        <div id="direccionx" class="campo">${lic.direccionx  ?? 'JOSE ARAMBURO #15 APIZACO, TLAXCALA.'}</div>
        <div id="horario" class="campo">${lic.Horario  ?? '9:00 am - 10:00 pm'}</div>
        <div id="fecha1" class="campo">${dia}</div>
        <div id="fecha2" class="campo">${mes}</div>
        <div id="fecha3" class="campo">${anio}</div>


        <script>
          window.onload = function () {
            window.print();
          };
        </script>
      </body>
    </html>
  `;

  const ventana = window.open('', '_blank', 'width=800,height=600');
  if (ventana) {
    ventana.document.write(html);
    ventana.document.close();
  }
};




  const generarReportePDF = () => {
    const fecha = new Date();
    const fechaTexto = `${fecha.getDate().toString().padStart(2, '0')}/${(fecha.getMonth() + 1).toString().padStart(2, '0')}/${fecha.getFullYear()}`;
    
    // Calcular rango de fechas inteligente
    let rangoFechas = '';
    if (fechaDesde && fechaHasta) {
      // Si hay filtros de fecha específicos, usarlos
      rangoFechas = `${formatearFecha(fechaDesde)} - ${formatearFecha(fechaHasta)}`;
    } else if (sortedLicencias.length > 0) {
      // Si no hay filtros de fecha pero sí otros filtros, calcular rango automático
      const fechasValidas = sortedLicencias
        .map(lic => lic.fechaRegistro?.split('T')[0])
        .filter(Boolean)
        .sort();
      
      if (fechasValidas.length > 0) {
        const fechaMasAntigua = fechasValidas[0];
        const fechaMasReciente = fechasValidas[fechasValidas.length - 1];
        rangoFechas = fechaMasAntigua === fechaMasReciente 
          ? formatearFecha(fechaMasAntigua) 
          : `${formatearFecha(fechaMasAntigua)} - ${formatearFecha(fechaMasReciente)}`;
      } else {
        rangoFechas = 'Sin fechas disponibles';
      }
    } else {
      rangoFechas = 'Sin datos';
    }
    
    // Calcular estadísticas
    const totalLicencias = sortedLicencias.length;
    const totalMontoLicencias = sortedLicencias.reduce((sum, lic) => sum + (lic.montoLicencia || 0), 0);
    const totalMontoResiduos = sortedLicencias.reduce((sum, lic) => sum + (lic.montoResiduos || 0), 0);
    const girosMasComunes = sortedLicencias.reduce((acc: Record<string, number>, lic) => {
      const giro = lic.giro || 'Sin especificar';
      acc[giro] = (acc[giro] || 0) + 1;
      return acc;
    }, {});
    const topGiros = Object.entries(girosMasComunes)
      .sort(([,a], [,b]) => b - a)
      .slice(0, 3)
      .map(([giro, count]) => `${giro}: ${count}`)
      .join(', ');
    
    // Ordenar por fecha para el PDF (más reciente primero)
    const licenciasOrdenadas = [...sortedLicencias].sort((a, b) => {
      const fechaA = a.fechaRegistro || '';
      const fechaB = b.fechaRegistro || '';
      return fechaB.localeCompare(fechaA);
    });
    
    const filas = licenciasOrdenadas.map(lic => `
      <tr>
        <td style="text-align: center;">${lic.FolioLicencia ?? lic.Id}</td>
        <td>${lic.Ciudadano}</td>
        <td>${lic.nombreEstablecimiento ?? '—'}</td>
        <td>${lic.giro ?? '—'}</td>
        <td>${lic.localidad ?? '—'}</td>
        <td style="text-align: center;">${lic.fechaRegistro?.split('T')[0] ?? '—'}</td>
      </tr>
    `).join('');

    const html = `
      <!DOCTYPE html>
      <html lang="es">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Reporte de Licencias Comerciales</title>
          <style>
            @media print {
              @page {
                margin: 1.5cm;
                size: A4;
              }
              body {
                margin: 0;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              .no-print {
                display: none !important;
              }
            }
            
            * {
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Arial', sans-serif;
              margin: 0;
              padding: 15px;
              background: white;
              color: #333;
              line-height: 1.3;
              font-size: 12px;
            }
            
            .container {
              max-width: 100%;
              margin: 0 auto;
            }
            
            .header {
              margin-bottom: 25px;
              padding-bottom: 15px;
              border-bottom: 3px solid #5b182b;
            }
            
            .logo-section {
              display: flex;
              align-items: center;
              margin-bottom: 15px;
            }
            
            .logo {
              width: 120px;
              height: 80px;
              margin-right: 20px;
            }
            
            .header-text {
              flex: 1;
            }
            
            .title {
              color: #5b182b;
              font-size: 20px;
              font-weight: bold;
              margin: 0 0 5px 0;
              text-transform: uppercase;
            }
            
            .subtitle {
              color: #666;
              font-size: 14px;
              margin: 0 0 8px 0;
            }
            
            .date-range {
              color: #bb8c52;
              font-size: 16px;
              font-weight: bold;
              margin: 0;
            }
            
            .statistics {
              background: #f8f9fa;
              padding: 15px;
              border-radius: 5px;
              border: 2px solid #5b182b;
              margin: 20px 0;
            }
            
            .stat-title {
              color: #5b182b;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              margin: 0 0 15px 0;
              text-transform: uppercase;
            }
            
            .stat-grid {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr 1fr;
              gap: 10px;
            }
            
            .stat-item {
              background: white;
              padding: 10px;
              border-radius: 3px;
              border-left: 3px solid #bb8c52;
              text-align: center;
            }
            
            .stat-label {
              font-weight: bold;
              color: #333;
              font-size: 10px;
              margin-bottom: 3px;
              display: block;
            }
            
            .stat-value {
              color: #bb8c52;
              font-weight: bold;
              font-size: 18px;
              display: block;
            }
            
            .data-table {
              width: 100%;
              border-collapse: collapse;
              margin: 15px 0;
              font-size: 10px;
            }
            
            .data-table th,
            .data-table td {
              border: 1px solid #ddd;
              padding: 6px;
              text-align: left;
              vertical-align: top;
            }
            
            .data-table th {
              background-color: #5b182b;
              color: white;
              font-weight: bold;
              text-align: center;
              font-size: 9px;
            }
            
            .data-table tbody tr:nth-child(even) {
              background-color: #f8f9fa;
            }
            
            .footer {
              text-align: center;
              margin-top: 25px;
              padding-top: 15px;
              border-top: 1px solid #dee2e6;
              font-size: 10px;
              color: #666;
            }
            
            .giros-info {
              margin: 15px 0;
              font-size: 10pt;
              background: #f0f0f0;
              padding: 10px;
              border-radius: 3px;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <div class="logo-section">
                <img src="/img/logo.png" alt="Logo Ayuntamiento" class="logo">
                <div class="header-text">
                  <h1 class="title">Reporte de Licencias Comerciales</h1>
                  <h2 class="subtitle">H. Ayuntamiento de Totolac, Tlaxcala</h2>
                  <h3 class="date-range">Periodo: ${rangoFechas}</h3>
                </div>
              </div>
            </div>
            
            
            
            <div class="giros-info">
              <strong>Giros:</strong> ${topGiros}
            </div>
            
            <table class="data-table">
              <thead>
                <tr>
                  <th style="width: 10%;">Folio</th>
                  <th style="width: 25%;">Ciudadano</th>
                  <th style="width: 25%;">Establecimiento</th>
                  <th style="width: 20%;">Giro</th>
                  <th style="width: 10%;">Localidad</th>
                  <th style="width: 10%;">Fecha</th>
                </tr>
              </thead>
              <tbody>
                ${filas}
              </tbody>
            </table>
            
            <div class="footer">
              <p><strong>H. Ayuntamiento de Totolac</strong></p>
              <p>Desarrollo Económico - Tlaxcala, México</p>
              <p>Documento generado automáticamente el ${fechaTexto}</p>
            </div>
          </div>
          
          <script>
            window.onload = function() {
              window.focus();
              setTimeout(() => {
                window.print();
              }, 1000);
            };
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=1200,height=800');
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
    } else {
      alert('No se pudo abrir la ventana de impresión. Verifica que los popups estén habilitados.');
    }
  };

  const generarReporteExcel = async () => {
    // Importar la librería xlsx dinámicamente
    const XLSX = await import('xlsx');
    
    // Ordenar por fecha para Excel (más reciente primero)
    const licenciasOrdenadas = [...sortedLicencias].sort((a, b) => {
      const fechaA = a.fechaRegistro || '';
      const fechaB = b.fechaRegistro || '';
      return fechaB.localeCompare(fechaA);
    });
    
    // Preparar datos para Excel
    const data = licenciasOrdenadas.map(lic => ({
      'Folio': lic.FolioLicencia ?? lic.Id,
      'Ciudadano': lic.Ciudadano,
      'Establecimiento': lic.nombreEstablecimiento ?? '',
      'Giro': lic.giro ?? '',
      'Localidad': lic.localidad ?? '',
      'Dirección': ([lic.numero, lic.codigoPostal].filter(Boolean).join(', ') || lic.direccionx) ?? '',
      'Fecha': formatearFecha(lic.fechaRegistro),
      'Monto Licencia': lic.montoLicencia ?? 0,
      'Monto Residuos': lic.montoResiduos ?? 0
    }));

    // Crear libro de trabajo
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    
    // Configurar anchos de columna
    const colWidths = [
      { wch: 12 }, // Folio
      { wch: 30 }, // Ciudadano
      { wch: 25 }, // Establecimiento
      { wch: 20 }, // Giro
      { wch: 15 }, // Localidad
      { wch: 25 }, // Dirección
      { wch: 12 }, // Fecha
      { wch: 15 }, // Monto Licencia
      { wch: 15 }  // Monto Residuos
    ];
    ws['!cols'] = colWidths;
    
    // Agregar hoja al libro
    XLSX.utils.book_append_sheet(wb, ws, 'Licencias');
    
    // Generar archivo y descargarlo
    const fecha = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, `licencias_${fecha}.xlsx`);
  };

  const getEstatusIcon = (estatus: string | null) => {
    switch (estatus) {
      case 'Activa':
        return <Icon as={CheckCircleIcon} color="green.400" />;
      case 'En revisión':
        return <Icon as={TimeIcon} color="orange.400" />;
      case 'Suspendida':
        return <Icon as={WarningIcon} color="red.500" />;
      default:
        return <Icon as={InfoIcon} />;
    }
  };

  const filteredLicencias = licencias.filter((lic) => {
    const cumpleTexto = lic.FolioLicencia?.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      lic.Ciudadano.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      lic.nombreEstablecimiento?.toLowerCase().includes(filtroTexto.toLowerCase());
    
    const fechaLic = lic.fechaRegistro?.split('T')[0];
    const cumpleFecha = (!fechaDesde || fechaLic >= fechaDesde) && (!fechaHasta || fechaLic <= fechaHasta);
    
    const cumpleGiro = !filtroGiro || lic.giro?.toLowerCase().includes(filtroGiro.toLowerCase());
    
    const cumpleLocalidad = !filtroLocalidad || lic.localidad?.toLowerCase().includes(filtroLocalidad.toLowerCase());
    
    return cumpleTexto && cumpleFecha && cumpleGiro && cumpleLocalidad;
  });

 const sortedLicencias = [...filteredLicencias].sort((a, b) => {
  if (!sortConfig) {
    // Ordenamiento por defecto: fecha más reciente primero
    const fechaA = a.fechaRegistro || '';
    const fechaB = b.fechaRegistro || '';
    return fechaB.localeCompare(fechaA);
  }
  
  const aVal = a[sortConfig.key];
  const bVal = b[sortConfig.key];

  if (aVal === null || aVal === undefined) return 1;
  if (bVal === null || bVal === undefined) return -1;

  if (typeof aVal === 'string' && typeof bVal === 'string') {
    return sortConfig.direction === 'asc'
      ? aVal.localeCompare(bVal)
      : bVal.localeCompare(aVal);
  }

  if (typeof aVal === 'number' && typeof bVal === 'number') {
    return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
  }

  return 0;
});

  const totalPaginas = Math.ceil(sortedLicencias.length / registrosPorPagina);
  const indiceInicio = (paginaActual - 1) * registrosPorPagina;
  const indiceFin = indiceInicio + registrosPorPagina;
  const licenciasPaginadas = sortedLicencias.slice(indiceInicio, indiceFin);


  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
      <Box mb={4}>
        <Heading fontSize="md" mb={2}>Filtros de búsqueda</Heading>
        <InputGroup mb={3}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.400" />
          </InputLeftElement>
          <Input
            placeholder="Buscar por ciudadano o establecimiento"
            value={filtroTexto}
            onChange={(e) => setFiltroTexto(e.target.value)}
          />
        </InputGroup>
        
        <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
          <Box>
            <Text fontSize="sm" mb={1}>Fecha desde:</Text>
            <Input
              type="date"
              size="sm"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
            />
          </Box>
          <Box>
            <Text fontSize="sm" mb={1}>Fecha hasta:</Text>
            <Input
              type="date"
              size="sm"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
            />
          </Box>
          <Box>
            <Text fontSize="sm" mb={1}>Giro:</Text>
            <Input
              size="sm"
              placeholder="Filtrar por giro"
              value={filtroGiro}
              onChange={(e) => setFiltroGiro(e.target.value)}
            />
          </Box>
          <Box>
            <Text fontSize="sm" mb={1}>Localidad:</Text>
            <Input
              size="sm"
              placeholder="Filtrar por localidad"
              value={filtroLocalidad}
              onChange={(e) => setFiltroLocalidad(e.target.value)}
            />
          </Box>
        </SimpleGrid>
        
        <Flex justify="space-between" mt={3}>
          <Button
            size="sm"
            bg="#bb8c52"
            color="white"
            _hover={{ bg: "#a67a47" }}
            onClick={() => {
              setFiltroTexto('');
              setFechaDesde('');
              setFechaHasta('');
              setFiltroGiro('');
              setFiltroLocalidad('');
              setPaginaActual(1);
            }}
          >
            Limpiar Filtros
          </Button>
          <Flex gap={2}>
            <Button
              size="sm"
              bg="#5b182b"
              color="white"
              _hover={{ bg: "#691f30" }}
              leftIcon={<Icon as={FaFilePdf} />}
              onClick={generarReportePDF}
            >
              PDF
            </Button>
            <Button
              size="sm"
              bg="#681a2d"
              color="white"
              _hover={{ bg: "#5b182b" }}
              leftIcon={<Icon as={FaFileExcel} />}
              onClick={generarReporteExcel}
            >
              Excel
            </Button>
          </Flex>
        </Flex>
      </Box>

      <Table variant="simple" size="sm">
     <Thead bg="#5b182b">
  <Tr>
    <Th color="white" cursor="pointer" onClick={() => requestSort('FolioLicencia')}>Folio {getSortIcon('FolioLicencia')}</Th>
    <Th color="white" cursor="pointer" onClick={() => requestSort('Ciudadano')}>Ciudadano {getSortIcon('Ciudadano')}</Th>
    <Th color="white" cursor="pointer" onClick={() => requestSort('nombreEstablecimiento')}>Establecimiento {getSortIcon('nombreEstablecimiento')}</Th>
    <Th color="white" cursor="pointer" onClick={() => requestSort('giro')}>giro {getSortIcon('giro')}</Th>
    {/* <Th color="white" cursor="pointer" onClick={() => requestSort('tipo')}>tipo {getSortIcon('tipo')}</Th> */}
    {/* <Th color="white" cursor="pointer" onClick={() => requestSort('Movimiento')}>Movimiento {getSortIcon('Movimiento')}</Th> */}
    <Th color="white" cursor="pointer" onClick={() => requestSort('localidad')}>localidad {getSortIcon('localidad')}</Th>
    <Th color="white">Dirección</Th>
    {/* <Th color="white" cursor="pointer" onClick={() => requestSort('Horario')}>Horario {getSortIcon('Horario')}</Th> */}
    <Th color="white" cursor="pointer" onClick={() => requestSort('fechaRegistro')}>Fecha {getSortIcon('fechaRegistro')}</Th>
    {/* <Th color="white" cursor="pointer" textAlign="right" onClick={() => requestSort('montoLicencia')}>Monto  {getSortIcon('montoLicencia')}</Th> */}
    {/* <Th color="white" cursor="pointer" textAlign="right" onClick={() => requestSort('montoResiduos')}>Monto residuos {getSortIcon('montoResiduos')}</Th> */}
    <Th color="white" textAlign="center">Acciones</Th>
  </Tr>
</Thead>

       <Tbody>
  {licenciasPaginadas.map((lic) => (
    <Tr key={lic.Id}>
      <Td>{lic.FolioLicencia ?? lic.Id}</Td>
      <Td>{lic.Ciudadano}</Td>
      <Td>{lic.nombreEstablecimiento ?? '—'}</Td>
      <Td>{lic.giro ?? '—'}</Td>
      {/* <Td>{lic.tipo ?? '—'}</Td>
      <Td>{lic.Movimiento ?? '—'}</Td> */}
      <Td>{lic.localidad ?? '—'}</Td>
     <Td>
  {([ lic.numero, lic.codigoPostal].filter(Boolean).join(', ') || lic.direccionx) ?? '—'}
</Td>

      {/* <Td>{lic.Horario ?? '—'}</Td> */}
      <Td>{formatearFecha(lic.fechaRegistro)}</Td>
     {/* <Td isNumeric>${Number(lic.montoLicencia).toFixed(2)}</Td>
<Td isNumeric>
  {lic.residuos ? `$${Number(lic.montoResiduos).toFixed(2)}` : '—'}
</Td> */}
   <Td>
        <Flex justify="center" gap={2}>
          <Button size="xs" bg="#691f30" color="white" _hover={{ bg: "#5b182b" }} onClick={() => {
            setModoModal('view');
            setLicenciaSeleccionada(lic);
            onVerOpen();
          }}>Ver</Button>

          <Button size="xs" bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }} onClick={() => {
            setModoModal('edit');
            setLicenciaSeleccionada(lic);
            onVerOpen();
          }}>Editar</Button>
<Button
  size="xs"
  bg="#681a2d"
  color="white"
  _hover={{ bg: "#5b182b" }}
  onClick={() => {
    setLicenciaIdHistorial(lic.Id);
    onOpen();
  }}
>
              <Icon as={FaClock} />

</Button>

          <Button size="xs" bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }} onClick={() => imprimirLicencia(lic)}>
            <Icon as={FaPrint} />
          </Button>

          <Button size="xs" bg="#5b182b" color="white" _hover={{ bg: "#691f30" }} onClick={() => imprimirTicketLicencia(lic, Number(lic.montoLicencia)+Number(lic.montoResiduos) || 0)}>
            <Icon as={FaReceipt} />
          </Button>
        </Flex>
      </Td>
    </Tr>
  ))}
</Tbody>

      </Table>

      <Flex justify="space-between" align="center" mt={4}>
        <Text fontSize="sm" color="#691f30">
          Mostrando {indiceInicio + 1} - {Math.min(indiceFin, sortedLicencias.length)} de {sortedLicencias.length} registros
        </Text>
        <Flex gap={2}>
          <Button
            size="sm"
            bg="#bb8c52"
            color="white"
            _hover={{ bg: "#a67a47" }}
            isDisabled={paginaActual === 1}
            onClick={() => setPaginaActual(paginaActual - 1)}
          >
            Anterior
          </Button>
          {Array.from({ length: totalPaginas }, (_, i) => i + 1).map((pagina) => (
            <Button
              key={pagina}
              size="sm"
              bg={paginaActual === pagina ? "#5b182b" : "white"}
              color={paginaActual === pagina ? "white" : "#5b182b"}
              border="1px"
              borderColor="#5b182b"
              _hover={{ bg: paginaActual === pagina ? "#691f30" : "#f7f7f7" }}
              onClick={() => setPaginaActual(pagina)}
            >
              {pagina}
            </Button>
          ))}
          <Button
            size="sm"
            bg="#bb8c52"
            color="white"
            _hover={{ bg: "#a67a47" }}
            isDisabled={paginaActual === totalPaginas}
            onClick={() => setPaginaActual(paginaActual + 1)}
          >
            Siguiente
          </Button>
        </Flex>
      </Flex>

      {licenciaSeleccionada && (
        <ModalSolicitud
          isOpen={isVerOpen}
          onClose={onVerClose}
          archivos={{}}
          handleArchivoChange={() => {}}
          data={licenciaSeleccionada}
          modo={modoModal}
        />
      )}

      {licenciaIdHistorial && (
  <ModalHistorialLicencia
    isOpen={isOpen}
    onClose={onClose}
    licenciaId={licenciaIdHistorial}
  />
)}

    </Box>
  );
};

export default TablaLicencias;
